<template>
  <div>
    <h3>Kurse</h3>
    <div class="columns">

      <div class="column">
        <span class="is-small">Geldkurs Produkt</span><br>
        <span class="has-text-weight-bold" v-html="this.$options.filters.currency(productPriceBid, productCurrency)">
        </span>
      </div>
      <div class="column">
        <span class="is-small">Brief Produkt</span><br>
        <span class="has-text-weight-bold"
              v-html="this.$options.filters.currency(productPriceAsk, productCurrency)"></span>
      </div>
      <div class="column">
        <span class="is-small">Kurs Basiswert</span><br>
        <span class="has-text-weight-bold"
              v-html="this.$options.filters.currency(underlyingPrice , underlyingCurrency)"></span>
      </div>
      <div class="column">
        <span class="is-small">Zeitpunkt</span><br>
        <span class="has-text-weight-bold"
              v-html="this.$options.filters.date(underlyingTimestamp, 'DD.MM.YYYY HH:mm:ss')"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'report-base-figures',
  props: {
    productPriceBid: {
      type: Number
    },
    productPriceAsk: {
      type: Number
    },
    underlyingPrice: {
      type: Number
    },
    underlyingTimestamp: {
      type: String
    },
    productCurrency: {
      type: String
    },
    underlyingCurrency: {
      type: String
    }
  }

}

</script>



// WEBPACK FOOTER //
// ReportBaseFigures.vue?f99bbdb0